export default {
  GET_FACILITY_PRICING_PARAMETER(state, data) {
    state.facility_pricing_parameters = data.data;
  },
  GET_DELETED_FACILITY_PRICING_PARAMETER (state, data) {
    state.deleted_facility_pricing_parameter = data.data
  },
  GET_PRICED_FACILITY_PARAMETER(state, data) {
    state.priced_facility_parameter = data.data
  }
};
